import axios from './index'
const origin = "/co/line/",
    order = "/co/order/";


const listRoutes = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "LoadLineList", param).then(res => {
            resolve(res)
        })
    })
}
const getRoutes = () => {
    return new Promise(resolve => {
        axios.post(order + "GetAllLineName").then(res => {
            resolve(res)
        })
    })
}


const addRoute = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "AddAllLine", param).then(res => {
            resolve(res)
        })
    })
}

const getRouteDetail = (param) => {
    return new Promise(resolve => {
        axios.post(order + "GetLineDetails", param).then(res => {
            resolve(res)
        })
    })
}
const updateRoute = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "UpdateAllLine", param).then(res => {
            resolve(res)
        })
    })
}

const deleteRoute = param => {
    return new Promise(resolve => {
        axios.post(origin + "DeleteLine", param).then(res => {
            resolve(res)
        })
    })
}
export default {
    listRoutes,
    getRoutes,
    updateRoute,
    addRoute,
    getRouteDetail,
    deleteRoute
}